import cn from 'classnames/bind';
import React, { useEffect, useState } from 'react';

import { useFinanceFilter } from '@/hooks/filters/finance-filter.hook';
import { usePriceFilter } from '@/hooks/filters/price-filter.hook';
import { PriceModes } from '@/types/used-cars/used-cars.types';

import { MobileFilter } from '../../filters/mobile-filter/mobile-filter';

import { Finance } from './components/finance/finance';
import { Price } from './components/price/price';
import styles from './price-finance.module.scss';

const cx = cn.bind(styles);

export const PriceFinance: React.FC<{
  handleVisibleChange?: (isVisible: boolean) => void;
  isVisible?: boolean;
  onCloseMobileFilter?: () => void;
}> = ({ handleVisibleChange, isVisible, onCloseMobileFilter }) => {
  const { defaultPriceFilter, priceFilter, setPriceFilter } = usePriceFilter();
  const { financeFilter, setFinanceFilter } = useFinanceFilter();
  const [mode, setMode] = useState<PriceModes>(PriceModes.price);
  const [price, setPrice] = useState(priceFilter);
  const [finance, setFinance] = useState(financeFilter);

  useEffect(() => {
    if (isVisible) {
      setPrice(priceFilter);
      setFinance(financeFilter);
    }
  }, [isVisible]);

  const onClose = () => {
    setPriceFilter(price);
    setFinanceFilter(finance);
  };

  return (
    <MobileFilter
      title="Price / Finance"
      handleVisibleChange={handleVisibleChange}
      onClose={onClose}
      onCloseMobileFilter={onCloseMobileFilter}
    >
      <div className={styles.priceFinanceWrapper}>
        <div className={styles.priceFinanceTabsWrapper}>
          <button
            onClick={() => setMode(PriceModes.price)}
            className={cx(styles.priceFinanceTab, {
              priceFinanceTabActive: mode === PriceModes.price,
            })}
          >
            Price
          </button>
          <button
            onClick={() => setMode(PriceModes.finance)}
            className={cx(styles.priceFinanceTab, {
              priceFinanceTabActive: mode === PriceModes.finance,
            })}
          >
            Finance
          </button>
        </div>
        {mode === PriceModes.price && (
          <Price defaultPriceFilter={defaultPriceFilter} />
        )}
        {mode === PriceModes.finance && <Finance />}
      </div>
    </MobileFilter>
  );
};
